import React from 'react'

function Boost() {

    return(
        <section className="boost">
            <h2>Boost Your Links Today</h2>
            <a className="button" href="#shorten">Get Started</a>
        </section>
    )
}
export default Boost